import { Injectable } from '@angular/core';

import { AlertService, CupcakeFlavors, AlertType } from '@ipreo/ngx-sprinkles';

@Injectable()
export class NotifyService {
  private errShowing = false;
  public readonly message =
    'We had a problem loading the latest data. Please refresh the page.';

  public createMsg(message: string): void {
    this.errShowing = true;
    this.alertService
      .create({
        body: message,
        color: CupcakeFlavors.Danger,
        icon: 'fa fa-exclamation-circle',
        timeout: 8000,
        alertType: AlertType.toast
      })
      .onDestroy(() => {
        this.errShowing = false;
      });
  }

  public show(loading: boolean, error: string): void {
    if (!this.errShowing && error) {
      this.createMsg(this.message);
    }
  }

  public clear() {
    this.alertService.destroyAll();
  }

  public showSuccessMsg(message: string): void {
    this.alertService.create({
      body: `<b>${message}</b>`,
      alertType: AlertType.toast,
      color: CupcakeFlavors.Success,
      icon: 'fa fa-check-circle',
      timeout: 8000
    });
  }

  public showErrorMsg(message: string): void {
    this.alertService.create({
      body: message,
      color: CupcakeFlavors.Danger,
      icon: 'fa fa-exclamation-circle',
      timeout: 8000,
      alertType: AlertType.toast
    });
  }

  constructor(private alertService: AlertService) {}
}
